import React from "react";
import { Helmet } from "react-helmet-async";
import MediaQuery from "components/MediaQuery";
import RuneTips from "./RuneTips";
import FullRuneTree from "components/common/RuneTrees/FullRuneTree";
import { useValidatedChampionProfileParams, useChampionOverview } from "lib/hooks/championProfileHooks";
import { getOverview } from "api/data_parser/champion_overview.js";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getPercetange, numberWithCommas } from "lib/general-helper";
import { getNotFoundImg } from "@outplayed/riot-assets";

const RunesGuide = (props) => {
  const { getChampionName, getChampionIdByName } = getRiotAssetsContext();
  const { role, championId } = props;

  const { validatedParams } = useValidatedChampionProfileParams(championId, "build", { keepDefaultParams: true, ssr: true });

  const {
    data: championOverview,
    loading: fetchingChampionOverview,
    error: errorChampionOverview,
  } = useChampionOverview(championId, { ssr: true });

  if (fetchingChampionOverview) {
    return (
      <div className="runes-guide-container">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  const params = { ...validatedParams, role };
  const filteredChampionOverview = getOverview(championOverview, params);
  const championName = getChampionName(championId);
  const oppChampionId = getChampionIdByName(params.opp);
  const { rec_runes, stat_shards } = filteredChampionOverview || {};

  if (!rec_runes) {
    return (
      <div className="content-section champion-profile-error">
        <img className="not-found" src={getNotFoundImg()} alt="No data found" />
        No data found. Please try again or change filters.
      </div>
    );
  }

  const runeTreeProps = {
    primaryStyle: rec_runes.primary_style,
    subStyle: rec_runes.sub_style,
    activePerks: rec_runes.active_perks,
    activeShards: stat_shards.activeShards,
    patch: params.patch,
    ssr: true,
  };

  return (
    <div className="runes-guide-container">
      <div className="content-section content-section_no-padding runes-guide">
        <div className="content-section_content rune-tree">
          <div className="content-section_header">
            <div style={{ flex: 1 }}>Best {championName} Runes</div>
            <div className="wr-matches">
              <span className={"win-rate"}>{`${getPercetange(rec_runes.wins, rec_runes.matches, 2)}% WR `}</span>
              <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
                <span className="matches">{`(${numberWithCommas(rec_runes.matches)} Matches)`}</span>
              </MediaQuery>
            </div>
          </div>
          <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
            <FullRuneTree {...runeTreeProps} />
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <FullRuneTree {...runeTreeProps} isMobile />
          </MediaQuery>
        </div>
        <div className="content-section_content rune-tips">
          <RuneTips
            championId={championId}
            oppChampionId={oppChampionId}
            runes={rec_runes}
            statShards={stat_shards}
            role={role}
            rank={params.rank}
          />
        </div>
      </div>
    </div>
  );
};

export default RunesGuide;
